const GAP_COLOR_STOPS: ReadonlyArray<{ seconds: number; rgb: readonly [number, number, number] }> =
  [
    { seconds: 0, rgb: [91, 155, 213] },
    { seconds: 1, rgb: [91, 155, 213] },
    { seconds: 3, rgb: [107, 203, 119] },
    { seconds: 5, rgb: [232, 197, 71] },
    { seconds: 8, rgb: [232, 150, 92] },
  ]

const GAP_COLOR_RED: readonly [number, number, number] = [232, 92, 92]

/** Gap indicator for words accepted during overtime (matches gold tile preview text). */
export const OVERTIME_INTER_WORD_GAP_COLOR = '#ffefc0'

function lerpChannel(a: number, b: number, t: number) {
  return Math.round(a + (b - a) * t)
}

function rgbToCss([r, g, b]: readonly [number, number, number]) {
  return `rgb(${r}, ${g}, ${b})`
}

/** Smooth gradient from blue (fast) through green/yellow/orange to red (slow). */
export function interWordGapColor(gapSeconds: number): string {
  if (gapSeconds >= 8) {
    return rgbToCss(GAP_COLOR_RED)
  }

  for (let i = 0; i < GAP_COLOR_STOPS.length - 1; i++) {
    const start = GAP_COLOR_STOPS[i]!
    const end = GAP_COLOR_STOPS[i + 1]!
    if (gapSeconds <= end.seconds) {
      const span = end.seconds - start.seconds
      const t = span <= 0 ? 1 : (gapSeconds - start.seconds) / span
      return rgbToCss([
        lerpChannel(start.rgb[0], end.rgb[0], t),
        lerpChannel(start.rgb[1], end.rgb[1], t),
        lerpChannel(start.rgb[2], end.rgb[2], t),
      ])
    }
  }

  return rgbToCss(GAP_COLOR_RED)
}
